import { BulkActionType, JobStatus, PushScheduleBy } from '../constant';
import { JobQueryParams } from '../hooks/usePaginatedGetJobsQuery';

export enum JobRestrictionType {
  PAYRUN = 'payrun',
  DONE = 'done',
  UNSCHEDULED = 'unscheduled',
  NO_EDIT_PERMISSION = 'noEditPermission',
  NO_DONE_PERMISSION = 'noDonePermission'
}

export interface BulkActionNotEditableCounts {
  noPermissionToEditJobCount: number;
  notEditableWithRespectToPayrunJobCount: number;
  noPermissionToModifyDoneJobCount: number;
  noPermissionToMarkJobAsDoneCount?: number;
  noScheduleJobCount?: number;
}

export interface BulkActionBaseParams {
  jobIds: string[];
  isSelectedAll?: boolean;
  excludedJobIds?: string[];
  isConfirmed?: boolean;
  filter?: Partial<JobQueryParams>;
}

export interface BulkRescheduleParams extends BulkActionBaseParams {
  scheduledFrom?: string;
  scheduledTo?: string;
  pushScheduleBy?: PushScheduleBy;
  pushScheduleByValue?: number;
}

export interface BulkStatusUpdateParams extends BulkActionBaseParams {
  status: JobStatus;
}

export interface BulkReassignParams extends BulkActionBaseParams {
  assignees: string[];
  serviceAreaId?: string;
}

export interface BulkTagsUpdateParams extends BulkActionBaseParams {
  tagIds: string[];
  removeExistingTags: boolean;
}

export interface BulkActionResponse {
  data: {
    showPopup: boolean;
    updateCompleted: boolean;
    noPermissionToEditJobCount: number;
    notEditableWithRespectToPayrunJobCount: number;
    noPermissionToModifyDoneJobCount: number;
    noPermissionToMarkJobAsDoneCount?: number;
    noScheduleJobCount?: number;
    updatePossibleJobCount: number;
  };
}

export interface BulkActionState {
  actionType: BulkActionType;
  totalJobs: number;
  actionParams: {
    scheduledFrom?: string;
    scheduledTo?: string;
    pushScheduleBy?: PushScheduleBy;
    pushScheduleByValue?: number;
    status?: JobStatus;
    assignees?: string[];
    serviceAreaId?: string;
    tagIds?: string[];
    removeExistingTags?: boolean;
  };
  possibleJobCount: number;
  notEditableCounts: BulkActionNotEditableCounts;
}
